import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiClient } from "../../config/api";
import { ColorArray } from "../../config/ColorArray";
import "./NavUjaniye.css";
import Loader from "../../common/Loader";
import { imageUrl } from "../../utils/imageUrl";   // ✅ ADDED
import SectionDivider from "../../common/SectionDivider";

const NavUjaniye = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchNavUjaniye = async () => {
            const endpoints = [
                "/navu-janiye",
                "/navu_janiye",
                "/know-about",
                "/about",
                "/navu-janiye-data"
            ];

            let lastError = null;

            for (const endpoint of endpoints) {
                try {
                    const res = await apiClient.get(endpoint);

                    let navUjaniyeData = [];

                    if (Array.isArray(res.data)) {
                        navUjaniyeData = res.data;
                    } else if (res.data?.data && Array.isArray(res.data.data)) {
                        navUjaniyeData = res.data.data;
                    } else if (res.data?.result && Array.isArray(res.data.result)) {
                        navUjaniyeData = res.data.result;
                    } else if (res.data?.navu_janiye && Array.isArray(res.data.navu_janiye)) {
                        navUjaniyeData = res.data.navu_janiye;
                    } else {
                        // Extract array inside object
                        const values = Object.values(res.data);
                        const arr = values.find(v => Array.isArray(v));
                        if (arr) navUjaniyeData = arr;
                    }

                    if (navUjaniyeData.length > 0) {
                        const sortedData = navUjaniyeData.sort((a, b) => {
                            const indexA = parseInt(a.index) || 0;
                            const indexB = parseInt(b.index) || 0;
                            return indexA - indexB;
                        });

                        setData(sortedData);
                        setLoading(false);
                        return;
                    }
                } catch (err) {
                    lastError = err;
                }
            }

            if (lastError) {
                setError(lastError.message || "Failed to fetch data");
                setData([]);
            }

            setLoading(false);
        };

        fetchNavUjaniye();
    }, []);

    const getCardColor = (index) => {
        return ColorArray[index % ColorArray.length];
    };

    if (loading) {
        return (
            <div className="nav-ujaniye-container">
                <Loader />
            </div>
        );
    }

    if (error) {
        return (
            <div className="nav-ujaniye-container">
                <div className="nav-ujaniye-error">
                    <h2>⚠️ Error</h2>
                    <p>{error}</p>
                </div>
            </div>
        );
    }

    return(
        <>
         <SectionDivider title="ચાલો નવું જાણીએ" />
        <div className="nav-ujaniye-container">
           
            {data.length === 0 ? (
                <div className="nav-ujaniye-empty">
                    <div className="nav-ujaniye-empty-icon">📭</div>
                    <p>No data found at the moment.</p>
                </div>
            ) : (
                
                <div className="nav-ujaniye-grid">
                   
                    {data.map((item, index) => {
                        const colors = getCardColor(index);

                        // Detect image value from API  
                        const rawImage =
                            item.navu_janiye_image ||
                            item.image ||
                            item.icon ||
                            item.img ||
                            "";

                        const finalImage = rawImage ? imageUrl(rawImage) : null;  // ✅ MAIN FIX

                        const navId = item.id || item._id;
                        const navTitle =
                            item.navu_janiye_title_gujarati ||
                            item.navu_janiye_title_english ||
                            item.navu_janiye_title_hindi ||
                            item.title ||
                            "ચાલો નવું જાણીએ";

                        return (
                            <div
                                key={item.id || item._id}
                                className="nav-ujaniye-card"
                                style={{
                                    background: `linear-gradient(135deg, ${colors.color1} 0%, ${colors.color2} 100%)`,
                                }}
                                onClick={() => {
                                    if (navId == null) return;
                                    navigate(`/navu_janiye/${navId}`, {
                                        state: { title: navTitle },
                                    });
                                }}
                            >
                                <div className="nav-ujaniye-card-content">

                                    {/* IMAGE BLOCK */}
                                    <div className="nav-ujaniye-card-image-wrapper">
                                        {finalImage ? (
                                            <img
                                                src={finalImage}
                                                alt={item.navu_janiye_title_gujarati || item.title}
                                                className="nav-ujaniye-card-image"
                                                onError={(e) => {
                                                    e.target.style.display = "none";
                                                }}
                                            />
                                        ) : (
                                            <div className="nav-ujaniye-card-image-placeholder">📚</div>
                                        )}
                                    </div>

                                    {/* TITLE BLOCK */}
                                    <div className="nav-ujaniye-card-titles">
                                        {item.navu_janiye_title_gujarati && (
                                            <h3 className="nav-ujaniye-card-title nav-ujaniye-title-gujarati">
                                                {item.navu_janiye_title_gujarati}
                                            </h3>
                                        )}

                                        {item.navu_janiye_title_english && (
                                            <h4 className="nav-ujaniye-card-subtitle nav-ujaniye-title-english">
                                                {item.navu_janiye_title_english}
                                            </h4>
                                        )}

                                        {item.navu_janiye_title_hindi && (
                                            <h4 className="nav-ujaniye-card-subtitle nav-ujaniye-title-hindi">
                                                {item.navu_janiye_title_hindi}
                                            </h4>
                                        )}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );

           </>
    );
};

export default NavUjaniye;
